import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CartConnector } from '@spartacus/cart/base/core';
import { SavedCartFormDialogComponent } from '@spartacus/cart/saved-cart/components';
import { UserIdService } from '@spartacus/core';

@Component({
  selector: 'app-custom-save-cart-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './custom-save-cart-modal.component.html',
  styleUrl: './custom-save-cart-modal.component.scss',
})
export class CustomSaveCartModalComponent extends SavedCartFormDialogComponent {
  cartConnector = inject(CartConnector);
  userService = inject(UserIdService);
  maxLength = 255;
  remainingCharsName = this.maxLength;
  remainingCharsDescription = this.maxLength;

  saveCart(code: string) {
    const { name, description } = this.form.value;

    this.userService.getUserId().subscribe((u) => {
      this.savedCartService.saveCart({
        cartId: code,
        saveCartName: name,
        saveCartDescription: description,
      });
    });
  }

  updateRemainingCharsName(event: any, target: string) { // NOSONAR
    const inputLength = event.target.value.length;
    this.remainingCharsName = this.maxLength - inputLength;
  }

  updateRemainingCharsDescription(event: any, target: string) { // NOSONAR
    const inputLength = event.target.value.length;
    this.remainingCharsDescription = this.maxLength - inputLength;
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.form.reset();
  }
}
